module.exports = __webpack_public_path__ + "static/media/Image04.e4da5c39.png";